import { render, staticRenderFns } from "./IssueCustomer.vue?vue&type=template&id=e7af13b2&scoped=true"
import script from "./IssueCustomer.vue?vue&type=script&lang=js"
export * from "./IssueCustomer.vue?vue&type=script&lang=js"
import style0 from "./IssueCustomer.vue?vue&type=style&index=0&id=e7af13b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7af13b2",
  null
  
)

export default component.exports